var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tileFill",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F3B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1B2325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0B1211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050B09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tileRim",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8A9597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#465050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E1614"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gMain",
    gradientUnits: "userSpaceOnUse",
    x1: 140.1,
    y1: 0,
    x2: 881.8,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56E9AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FDA95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gTip",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 165.9,
    x2: 0,
    y2: 254.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A78BFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A78BFF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A78BFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBot",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 658.1,
    x2: 0,
    y2: 792.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3DBFB9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DBFB9",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gEcho",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 395.6,
    x2: 0,
    y2: 845.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3C8F8B",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3AA6A2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3AB0AC",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DBFB9",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 30,
    result: "b1"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "b1",
    result: "g1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.42
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 10,
    result: "b2"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "b2",
    result: "g2"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.3
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "g1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "g2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 171
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "url(#tileFill)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "160.71,547.23 329.66,547.23 391.47,828.27 506.85,395.59 556.30,547.23 865.35,547.23",
    fill: "none",
    stroke: "url(#gEcho)",
    strokeWidth: 35.03,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "157.62,507.88 320.59,507.88 379.11,776.76 504.79,183.37 574.64,507.88 864.32,507.88",
    fill: "none",
    stroke: "url(#gMain)",
    strokeWidth: 35.03,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "157.62,507.88 320.59,507.88 379.11,776.76 504.79,183.37 574.64,507.88 864.32,507.88",
    fill: "none",
    stroke: "url(#gTip)",
    strokeWidth: 35.03,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "157.62,507.88 320.59,507.88 379.11,776.76 504.79,183.37 574.64,507.88 864.32,507.88",
    fill: "none",
    stroke: "url(#gBot)",
    strokeWidth: 35.03,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 1019,
    height: 1019,
    rx: 168.5,
    fill: "none",
    stroke: "url(#tileRim)",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3889558da2066faddaf4b11fa31c4f34.svg";
export { ForwardRef as ReactComponent };